<!-- 
	This is the Dashboards default page, it uses the dashboard layout in: 
	"./layouts/Dashboard.vue" .
 -->

<template>

    <div>

        <a-row type="flex" :gutter="24">
            <a-col :span="12">
                <div style="display: flex; flex-direction: column">
                    <a-col :span="24" class="mb-10">
                        <a-checkbox v-model="isViewWeekly">Tampil Mingguan</a-checkbox>
                    </a-col>
                    <a-col :span="24" class="mb-24">
                        <label style="margin-right: 15px"><strong>Klinik</strong></label>
                        <a-dropdown :trigger="['click']">
                            <a-button class="ant-dropdown-link" @click="e => e.preventDefault()">
                                {{ filterKlinik === 'all' ? 'Semua' : departments.length ? departments.find(x => x.id == filterKlinik).nama_departemen : '-' }}
                                <a-icon class="ml-5" type="down"/>
                            </a-button>
                            <a-menu slot="overlay">
                                <a-menu-item :key="0" @click="setFilterKlinik('all')">Semua</a-menu-item>
                                <a-menu-item :key="i + 1" @click="setFilterKlinik(dep.id)" v-for="(dep, i) in departments">{{ dep.nama_departemen }}</a-menu-item>
                            </a-menu>
                        </a-dropdown>

                    </a-col>
                </div>
            </a-col>
            <a-col :span="12" class="mb-24" align="right">
                <a-button type="primary" @click="tambah()">Tambah</a-button>
            </a-col>
        </a-row>

        <a-card v-if="!isViewWeekly" :bordered="false" class="header-solid mb-24" :bodyStyle="{padding: 0, paddingTop: '16px'}">

            <!-- Table search -->
            <div class="mx-25">
                <a-row type="flex" :gutter="24">
                    <a-col :span="24" class="text-right">
                        <a-input-search placeholder="input search text" style="max-width: 200px;" v-model="query"/>
                    </a-col>
                </a-row>
            </div>
            <!-- / Table search -->

            <!-- Orders table -->
            <a-table class="mt-20"
                     :columns="columns"
                     :data-source="formattedData"
                     :pagination="{pageSize: 10}"
                     rowKey="id"
            >

                <template slot="id" slot-scope="no">#{{ no }}</template>

                <template slot="hari" slot-scope="row">
                    {{ row.day != -1 ? getDay(row.day) : '-' }}
                </template>

                <template slot="tanggal" slot-scope="row">
                    {{ row.date ? formatDate(row.date) : '-' }}
                </template>

                <template slot="jam" slot-scope="row">
                    {{ row.start_time }} - {{ row.end_time }}
                </template>

                <template slot="active" slot-scope="row">
                    {{ row.active ? '✓' : '✗' }}
                </template>

                <template slot="aksi" slot-scope="row">
                    <a-button type="primary" :data-id="row.id" @click="edit(row)" style="margin-right: 7px">
                        Ubah
                    </a-button>
                    <a-button type="danger" :data-id="row.id" @click="hapus(row)" style="margin-right: 7px">
                        Hapus
                    </a-button>
                </template>

            </a-table>
            <!-- / Orders table -->

        </a-card>

        <div v-if="isViewWeekly">
            <table id="tbl-week">
                <thead>
                    <tr>
                        <th>Klinik</th>
                        <th>Senin</th>
                        <th>Selasa</th>
                        <th>Rabu</th>
                        <th>Kamis</th>
                        <th>Jumat</th>
                        <th>Sabtu</th>
                        <th>Minggu</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="dep in filteredDepartments">
                        <td><strong>{{ dep.nama_departemen }}</strong></td>
                        <td v-for="day in [1, 2, 3, 4, 5, 6, 0]" class="jadwal-td">
                            <div class="jadwal" :class="{not_current: !x.sch_current, inactive: !parseInt(x.active)}" v-for="x in getWeeklyByDay(dep.id, day)" @click="edit(x)">
                                <div class="jadwal-delete" @click.stop="hapus(x)">X</div>

                                <div class="jadwal-time">{{ x.start_time }} - {{ x.end_time }}<div v-if="x.date" style="font-size: 11px">({{ formatDate(x.date) }})</div></div>
                                <div class="jadwal-dpjp" v-if="!x.can_collapse">{{ x.dpjp_name }}</div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <a-modal v-model:visible="showModal" :title="isInsert ? 'Tambah Data' : 'Ubah Data'">
            <a-row>
                <a-col
                    :span="24"
                    :md="24"
                    :sm="24"
                    :xs="24"
                >
                    <label class="item-label"><sup>*</sup> DPJP</label>

                    <a-select v-if="isInsert" class="mt-5" style="width:100%;" v-model:value="form.dpjp_id" placeholder="- Pilih DPJP -" show-search
                              :filter-option="filterOptions"
                              :options="dpjps">
                    </a-select>

                    <a-input v-if="!isInsert" class="mt-5" style="width:100%;" read-only v-model="editDpjpName"/>

                </a-col>
            </a-row>
            <a-row class="mt-10">
                <a-col
                    :span="24"
                    :md="24"
                    :sm="24"
                    :xs="24"
                >
                    <a-checkbox v-model="form.is_date" id="ckbIsDate"/>
                    <label class="item-label" for="ckbIsDate"> Per Tanggal</label>

                </a-col>
            </a-row>

            <a-row class="mt-10" v-if="form.is_date">
                <a-col
                    :span="24"
                    :md="24"
                    :sm="24"
                    :xs="24"
                >
                    <label class="item-label"><sup>*</sup> Tanggal</label>

                    <a-date-picker style="width: 100%; margin-top: 5px" placeholder="Tanggal" v-model="form.date" format="DD-MM-YYYY"/>

                </a-col>
            </a-row>

            <a-row class="mt-10" v-else>
                <a-col
                    :span="24"
                    :md="24"
                    :sm="24"
                    :xs="24"
                >
                    <label class="item-label"><sup>*</sup> Hari</label>

                    <a-select class="mt-5" style="width:100%;" v-model="form.day" placeholder="- Pilih Hari -">
                        <a-select-option :key="1" value="1">Senin</a-select-option>
                        <a-select-option :key="2" value="2">Selasa</a-select-option>
                        <a-select-option :key="3" value="3">Rabu</a-select-option>
                        <a-select-option :key="4" value="4">Kamis</a-select-option>
                        <a-select-option :key="5" value="5">Jumat</a-select-option>
                        <a-select-option :key="6" value="6">Sabtu</a-select-option>
                        <a-select-option :key="0" value="0">Minggu</a-select-option>
                    </a-select>

                </a-col>
            </a-row>

            <a-row class="mt-10">
                <a-col
                    :span="24"
                    :md="24"
                    :sm="24"
                    :xs="24"
                >
                    <label class="item-label"><sup>*</sup> Kuota</label>

                    <a-input-number class="mt-5" style="width:100%;" v-model="form.qty_max">

                    </a-input-number>

                </a-col>
            </a-row>

            <a-row class="mt-10" type="flex" style="gap: 5px">
                <a-col
                    :span="24 / form.num_time"
                    :md="24 / form.num_time"
                    :sm="24 / form.num_time"
                    :xs="24 / form.num_time"
                    style="flex: 1"
                >
                    <label class="item-label"><sup>*</sup> Jam Mulai</label>

<!--                    <a-time-picker use24-hours format="HH:mm" class="mt-5" style="width:100%;" v-model="form.start_time"/>-->
                    <a-select class="mt-5" style="width:100%;" v-model:value="form.start_time" placeholder="- Pilih Jam -" :options="times"></a-select>

                </a-col>

                <a-col
                    :span="24 / form.num_time"
                    :md="24 / form.num_time"
                    :sm="24 / form.num_time"
                    :xs="24 / form.num_time"
                    style="flex: 1"
                    v-for="(i, index) in form.start_times"
                >
                    <label class="item-label"><sup>*</sup> Jam Mulai {{ index + 2 }}</label>
                    <div class="btn-remove-time" @click="removeTime(index)">x</div>

<!--                    <a-time-picker use24-hours format="HH:mm" class="mt-5" style="width:100%;" v-model="form.start_times[index]"/>-->
                    <a-select class="mt-5" style="width:100%;" v-model:value="form.start_times[index]" placeholder="- Pilih Jam -" :options="times"></a-select>

                </a-col>
            </a-row>

            <a-row class="mt-10" type="flex" style="gap: 5px">
                <a-col
                    :span="24 / form.num_time"
                    :md="24 / form.num_time"
                    :sm="24 / form.num_time"
                    :xs="24 / form.num_time"
                    style="flex: 1"
                >
                    <label class="item-label"><sup>*</sup> Jam Selesai</label>

<!--                    <a-time-picker use24-hours format="HH:mm" class="mt-5" style="width:100%;" v-model="form.end_time"/>-->
                    <a-select class="mt-5" style="width:100%;" v-model:value="form.end_time" placeholder="- Pilih Jam -" :options="times"></a-select>

                </a-col>

                <a-col
                    :span="24 / form.num_time"
                    :md="24 / form.num_time"
                    :sm="24 / form.num_time"
                    :xs="24 / form.num_time"
                    style="flex: 1"
                    v-for="(i, index) in form.end_times"
                >
                    <label class="item-label"><sup>*</sup> Jam Selesai {{ index + 2 }}</label>

<!--                    <a-time-picker use24-hours format="HH:mm" class="mt-5" style="width:100%;" v-model="form.end_times[index]"/>-->
                    <a-select class="mt-5" style="width:100%;" v-model:value="form.end_times[index]" placeholder="- Pilih Jam -" :options="times"></a-select>

                </a-col>
            </a-row>

            <a-row class="mt-10">
                <a-col
                    :span="24"
                    :md="24"
                    :sm="24"
                    :xs="24"
                >
                    <a-checkbox v-model="form.active" id="ckbActive"/>
                    <label class="item-label" for="ckbActive"> Aktif</label>

                </a-col>
            </a-row>

            <a-button v-if="isInsert && form.num_time < 4" class="mt-10" type="default" @click="addTime">Tambah Jam</a-button>
            <a-button v-if="isInsert" class="mt-10 ml-5" type="default" @click="templateFullDay">Full Day (08:00 - 16:00)</a-button>

            <template #footer>
                <a-button key="back" @click="cancel">Batal</a-button>
                <a-button key="submit" type="primary" @click="submit">Simpan</a-button>
            </template>
        </a-modal>

    </div>

</template>

<script>


// Table columns
import DpjpScheduleApi from "../../../repository/api/DpjpScheduleApi";
import DpjpApi from "../../../repository/api/DpjpApi";
import moment from "moment";
import DepartementApi from "../../../repository/api/DepartementApi";
import SettingRepository from "../../../repository/SettingRepository";

const columns = [
    {
        title: 'No',
        dataIndex: 'no',
        sorter: (a, b) => a.no - b.no,
        sortDirections: ['descend', 'ascend'],
        scopedSlots: {customRender: 'id'},
    },
    {
        title: 'Nama DPJP',
        dataIndex: 'dpjp_name',
        sorter: (a, b) => (a.dpjp_name ?? "").localeCompare(b.dpjp_name),
        sortDirections: ['descend', 'ascend'],
    },
    {
        title: 'Hari',
        scopedSlots: {customRender: 'hari'},
        sorter: (a, b) => (a.day ?? "").localeCompare(b.day),
        sortDirections: ['descend', 'ascend'],
    },
    {
        title: 'Tanggal',
        scopedSlots: {customRender: 'tanggal'},
        sorter: (a, b) => (a.date ?? "").localeCompare(b.date),
        sortDirections: ['descend', 'ascend'],
    },
    {
        title: 'Jam',
        scopedSlots: {customRender: 'jam'},
    },
    {
        title: 'Kuota',
        dataIndex: 'qty_max',
    },
    {
        title: 'Aktif',
        scopedSlots: {customRender: 'active'},
        sorter: (a, b) => a.active.localeCompare(b.active),
        sortDirections: ['descend', 'ascend'],
    },
    {
        title: 'Aksi',
        scopedSlots: {customRender: 'aksi'},
    },
]

const days = [
    "Minggu",
    "Senin",
    "Selasa",
    "Rabu",
    "Kamis",
    "Jumat",
    "Sabtu",
]

const times = [
    '06:00',
    '07:00',
    '08:00',
    '09:00',
    '10:00',
    '11:00',
    '12:00',
    '13:00',
    '14:00',
    '15:00',
    '16:00',
    '17:00',
    '18:00',
]

export default {
    name: "JadwalDokterAdmin",

    data() {
        return {
            columns,
            data: [],
            dpjps: [],

            times: [],

            isViewWeekly: SettingRepository.get("DashboardAdmin", "isViewWeekly") == 'true',
            filterKlinik: SettingRepository.get("DashboardAdmin", "filterKlinik") ?? 'all',

            query: '',
            dpjpSearch: '',

            showModal: false,
            isInsert: true,
            editId: '',
            editDpjpName: '',

            form: {
                dpjp_id: undefined,
                is_date: false,
                day: undefined,
                date: undefined,
                qty_max: undefined,
                active: true,

                start_time: undefined,
                end_time: undefined,

                num_time: 1,
                start_times: [],
                end_times: [],
            },
        }
    },

    async mounted() {
        this.getData()
        this.getDpjp()

        await this.$store.dispatch('apiData/getDepartment')

        this.times = times.map(x => ({
            value: x,
            label: x
        }))
    },

    methods: {
        getData() {
            DpjpScheduleApi.get()
                .then((response) => {
                    this.data = response
                })
                .catch((e) => {
                    this.$swal({
                        icon: e.severity || "error",
                        title: (e.severity || "error").toUpperCase(),
                        text: e.message,
                    })
                })
        },

        getDpjp() {
            DpjpApi.get()
                .then((response) => {
                    this.dpjps = response.map(x => ({
                        value: x.id,
                        label: x.nama
                    }))
                })
                .catch((e) => {
                    this.$swal({
                        icon: e.severity || "error",
                        title: (e.severity || "error").toUpperCase(),
                        text: e.message,
                    })
                })
        },

        getDay(day) {
            return days[day]
        },

        tambah() {
            this.clearForm()

            this.isInsert = true
            this.showModal = true
        },

        edit(row) {
            this.showModal = true

            this.isInsert = false

            this.editId = row.id
            this.editDpjpName = row.dpjp_name

            this.form.dpjp_id = row.dpjp_id

            if (row.date) {
                this.form.is_date = true
                this.form.date = moment(row.date)
            }
            else {
                this.form.is_date = false
                this.form.day = row.day
            }

            this.form.qty_max = row.qty_max
            // this.form.start_time = moment(row.start_time, 'HH:mm')
            // this.form.end_time = moment(row.end_time, 'HH:mm')
            this.form.start_time = row.start_time
            this.form.end_time = row.end_time
            this.form.num_time = 1
            this.form.active = parseInt(row.active) === 1
        },

        hapus(row) {
            this.$swal({
                icon: "question",
                text: "Apakah anda yakin ingin menghapus data?",
                showDenyButton: true,
                confirmButtonText: 'Ya',
                denyButtonText: 'Batal',
            })
                .then((result) => {
                    if (result.isConfirmed) {
                        DpjpScheduleApi.delete(row.id)
                            .then((response) => {
                                this.$swal({
                                    icon: "success",
                                    title: "Sukses",
                                    text: "Berhasil menghapus data",
                                })

                                this.getData()
                            })
                            .catch((e) => {
                                this.$swal({
                                    icon: e.severity || "error",
                                    title: (e.severity || "error").toUpperCase(),
                                    text: e.message,
                                })
                            })
                    }
                })
        },

        submit() {
            if (!this.form.dpjp_id) {
                this.$swal({
                    icon: "warning",
                    text: "Silahkan pilih DPJP terlebih dahulu",
                })

                return
            }
            else if (!this.form.is_date && !this.form.day) {
                this.$swal({
                    icon: "warning",
                    text: "Silahkan pilih hari terlebih dahulu",
                })

                return
            }
            else if (this.form.is_date && !this.form.date) {
                this.$swal({
                    icon: "warning",
                    text: "Silahkan pilih tangal terlebih dahulu",
                })

                return
            }
            else if (!this.form.qty_max) {
                this.$swal({
                    icon: "warning",
                    text: "Silahkan isi kuota terlebih dahulu",
                })

                return
            }
            else if (!this.form.start_time) {
                this.$swal({
                    icon: "warning",
                    text: "Silahkan pilih jam mulai terlebih dahulu",
                })

                return
            }
            else if (!this.form.end_time) {
                this.$swal({
                    icon: "warning",
                    text: "Silahkan pilih jam selesai terlebih dahulu",
                })

                return
            }
            else if (this.form.start_times.findIndex(x => !x) >= 0) {
                this.$swal({
                    icon: "warning",
                    text: "Silahkan pilih jam mulai terlebih dahulu",
                })

                return
            }
            else if (this.form.end_times.findIndex(x => !x) >= 0) {
                this.$swal({
                    icon: "warning",
                    text: "Silahkan pilih jam selesai terlebih dahulu",
                })

                return
            }

            if (this.isInsert) {
                // const startTimeAr = [this.form.start_time.format('HH:mm')]
                // const endTimeAr = [this.form.end_time.format('HH:mm')]
                const startTimeAr = [this.form.start_time]
                const endTimeAr = [this.form.end_time]

                if (this.form.num_time > 1) {
                    for (let a = 0; a < this.form.start_times.length; a++) {
                        // startTimeAr.push(this.form.start_times[a].format('HH:mm'))
                        // endTimeAr.push(this.form.end_times[a].format('HH:mm'))
                        startTimeAr.push(this.form.start_times[a])
                        endTimeAr.push(this.form.end_times[a])
                    }
                }

                DpjpScheduleApi.add({
                    dpjp_id: this.form.dpjp_id,
                    day: this.form.day ?? undefined,
                    date: this.form.date ? moment(this.form.date).format('YYYY-MM-DD') : undefined,
                    qty_max: this.form.qty_max,
                    start_time: startTimeAr.join(','),
                    end_time: endTimeAr.join(','),
                    active: this.form.active ? '1' : '0',
                })
                    .then((response) => {
                        this.$swal({
                            icon: "success",
                            title: "Sukses",
                            text: "Berhasil menambah data",
                        })

                        this.cancel()
                        this.getData()
                    })
                    .catch((e) => {
                        this.$swal({
                            icon: e.severity || "error",
                            title: (e.severity || "error").toUpperCase(),
                            text: e.message,
                        });
                    })
            }
            else {
                DpjpScheduleApi.edit(this.editId, {
                    dpjp_id: this.form.dpjp_id,
                    day: this.form.day ?? undefined,
                    date: this.form.date ? moment(this.form.date).format('YYYY-MM-DD') : undefined,
                    qty_max: this.form.qty_max,
                    // start_time: this.form.start_time.format('HH:mm'),
                    // end_time: this.form.end_time.format('HH:mm'),
                    start_time: this.form.start_time,
                    end_time: this.form.end_time,
                    active: this.form.active ? '1' : '0',
                })
                    .then((response) => {
                        this.$swal({
                            icon: "success",
                            title: "Sukses",
                            text: "Berhasil mengubah data",
                        })

                        this.cancel()
                        this.getData()
                    })
                    .catch((e) => {
                        this.$swal({
                            iicon: e.severity || "error",
                            title: (e.severity || "error").toUpperCase(),
                            text: e.message,
                        });
                    })
            }
        },

        cancel() {
            this.showModal = false
            this.clearForm()
        },

        clearForm() {
            this.editId = ''
            this.form.dpjp_id = undefined
            this.form.is_date = false
            this.form.day = undefined
            this.form.date = undefined
            this.form.qty_max = undefined
            this.form.start_time = undefined
            this.form.end_time = undefined
            this.form.active = true

            this.form.num_time = 1
            this.form.start_times = []
            this.form.end_times = []
        },

        getWeeklyByDay(departmentId, day) {
            const data = this.data
                .filter(x => {
                    if (x.departement_id != departmentId)
                        return false

                    if (parseInt(x.day) >= 0) {
                        return x.day == day
                    }
                    else {
                        return moment(x.date).day() == day
                    }
                })
                .sort((a, b) => a.start_time.localeCompare(b.start_time))
                .sort((a, b) => (a.date ?? "").localeCompare((b.date ?? "")))
                .map(x => ({
                    ...x,
                    sch_current: !x.date || moment(x.date).isBefore(moment().add(6, 'days'))
                }))

            for (let a = 0; a < data.length; a++) {
                if (a < data.length - 1 && data[a].dpjp_id == data[a + 1].dpjp_id) {
                    data[a].can_collapse = true
                }
                else {
                    data[a].can_collapse = false
                }
            }

            return data
        },

        filterOptions(input, option) {
            return (
                option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
            );
        },

        formatDate(date) {
            return moment(date).format('DD-MM-YYYY')
        },

        setFilterKlinik(klinik) {
            this.filterKlinik = klinik
        },

        addTime() {
            this.form.num_time++
            this.form.start_times.push(null)
            this.form.end_times.push(null)
        },

        removeTime(index) {
            this.form.num_time--
            this.form.start_times.splice(index, 1)
            this.form.end_times.splice(index, 1)
        },

        templateFullDay() {
            this.form.num_time = 4
            this.form.start_time = '08:00'
            this.form.end_time = '10:00'
            this.form.start_times = ['10:00', '12:00', '14:00']
            this.form.end_times = ['12:00', '14:00', '16:00']
        },
    },

    computed: {
        formattedData() {
            return this.data
                .filter(x => {
                    return x.dpjp_name.toLowerCase().includes(this.query.toLowerCase())
                })
                .map((value, index) => ({
                    ...value,
                    no: index + 1
                }))
        },

        formattedDpjp() {
            return this.dpjps
                .filter(x => {
                    return x.label.toLowerCase().includes(this.dpjpSearch)
                })
        },

        departments() {
            return this.$store.getters['apiData/department']
        },

        filteredDepartments() {
            if (this.filterKlinik === 'all')
                return this.departments
            else
                return this.departments.filter(x => x.id == this.filterKlinik)
        }
    },

    watch: {

        isViewWeekly: function (n, o) {
            SettingRepository.save("DashboardAdmin", "isViewWeekly", n)
        },

        filterKlinik: function (n, o) {
            SettingRepository.save("DashboardAdmin", "filterKlinik", n)
        },
    }
};
</script>

<style lang="scss" scoped>

.notif-badge {
    margin-left: 10px;
    background: #F5222D;
    color: white;
    padding: 4px;
    border-radius: 100px;
    font-size: 16px;
}

#tbl-week {
    width: 100%;

    th, td {
        border: 1px solid #84a8c4;
        padding: 7px;
        color: #2f7ab4;
        text-align: center;
    }

    th {
        width: 12.5%;
    }

    .jadwal-td {
        vertical-align: top;
    }
}

.jadwal {
    border: 1px solid #2f7ab4;
    border-radius: 3px;
    color: #2f7ab4;
    margin: 4px 0;
    cursor: pointer;
    position: relative;

    &.not_current {
        border: 1px solid #5a6879;
        color: #5a6879;

        .jadwal-time {
            background: #5a6879;
        }

        &:hover {
            .jadwal-time {
                background: #707d8c;
            }
        }
    }

    &.inactive {
        border: 1px solid #5d4665;
        color: #5d4665;

        .jadwal-time {
            background: #5d4665;
        }

        &:hover {
            .jadwal-time {
                background: #755d7e;
            }
        }
    }

    &:hover {
        background: #EEEEEE;

        .jadwal-time {
            background: #3986c2;
        }
    }

    .jadwal-delete {
        position: absolute;
        color: white;
        right: 3px;
        top: 0;
        padding: 0 3px;

        &:hover {
            background: #e14141;
        }
    }

    .jadwal-time {
        background: #2f7ab4;
        color: white;
        text-align: center;
        padding: 2px 0;
    }

    .jadwal-dpjp {
        text-align: center;
        padding: 4px;
    }
}

.btn-remove-time {
    display: inline-block;
    padding: 1px 6px;
    font-weight: bold;
    color: #2f7ab4;
    cursor: pointer;
    transition: background-color 0.15s;
    position: absolute;
    right: 0;
    top: 0;

    &:hover {
        background: rgba(0, 0, 0, 0.1);
    }
}

</style>
